import React, { useEffect, useState } from 'react'
import { CircularProgress, LinearProgress } from "@mui/material";
import documentServices from '../services/documentServices';
import useUserList from '../../../hooks/useUserList';
import useSystemMasterList from '../../../hooks/useSystemMasterList';
import moment from 'moment';
import DocumentForm from './DocumentForm';
import DocumentAttachment from './DocumentAttachment';
import DocumentImage from './DocumentImage';
import DocumentTextNote from './DocumentTextNote';
import DocumentVoiceNote from './DocumentVoiceNote';
import DocumentHyperlinkNote from './DocumentHyperlinkNote';
import DocumentTimeline from './DocumentTimeline';
import DocumentMasterUpdate from './DocumentMasterUpdate';
import DocumentAssign from './DocumentAssign';
import DocumentBarcodeAssign from './DocumentBarcodeAssign';



function DocumentDetailsComponent({documentId}) {
  
  const {getUserName} = useUserList();
  const [masters,getMasterLabel] = useSystemMasterList(['department',"document-category","document-status","document-type"]);

  const [loading,setLoadingStatus] = useState(false);
  const [documentDetails,setDocumentDetails] = useState(null)
  
  

  const getDocumentDetails = () =>{
      setLoadingStatus(true);
      documentServices.getById(documentId).then(res=>{
        setDocumentDetails(res.data);
      }).catch(error=>{
      }).finally(()=>{
        setLoadingStatus(false);
      })
  }

  const [timelinLoading,setTimelineLoadingStatus] = useState(false);
  const [documentTimeline,setDocumentTimeLine] = useState(null)
  const getTimeLine = () => {
    setTimelineLoadingStatus(true);
    documentServices.getTimeLine(documentId).then(res=>{
      setDocumentTimeLine(res.data);
    }).catch(error=>{
    }).finally(()=>{
      setTimelineLoadingStatus(false);
    })
  }

  const getDetailsWithTimeline = () =>{
    getDocumentDetails();
    getTimeLine();
  }

  useEffect(()=>{
    if(documentId){
      getDetailsWithTimeline();
    }
  },[documentId])

  return (
    <div className='row'>
      {loading &&
        <div className="col-md-12">
          <LinearProgress/>
        </div>
      }
      {documentDetails && !loading &&
        <div className='col-md-12'>
          <div className='row'>
            <div className='col-md-7 mt-3'>
              <div className="card">
                <div className='card-header'>
                  {documentDetails.title}
                  <span className='float-end me-2'><DocumentForm callBack={getDocumentDetails} data={documentDetails} masters={masters} /></span>
                </div>
                <div className='card-body'>
                  <div className='blockquote'>{documentDetails.details}</div>
                  <div><span className='fw-bold'>Document Date : </span>{moment(documentDetails.documentDate).format("LLL")}</div>
                  <br/>
                  <div className="blockquote-footer">{ getUserName(documentDetails.userId)} Created on {moment(documentDetails.createdAt).format("LLL")}</div>
                </div>
                <div className='card-footer'>
                  
                  <span className='me-2'><DocumentAttachment callBack={getTimeLine} documentId={documentDetails.id} /></span>
                  <span className='me-2'><DocumentImage callBack={getTimeLine} documentId={documentDetails.id} /></span>
                  <span className='me-2'><DocumentTextNote callBack={getTimeLine} documentId={documentDetails.id} /></span>
                  <span className='me-2'><DocumentVoiceNote callBack={getTimeLine} documentId={documentDetails.id} /></span>
                  <span className='me-2'><DocumentHyperlinkNote callBack={getTimeLine} documentId={documentDetails.id} /></span>
                  <span className='me-2'><DocumentBarcodeAssign callBack={getTimeLine} documentId={documentDetails.id} /></span>
                  
                  

                </div>
              </div>
            </div>
            <div className='col-md-5 mt-3'>
              <table className='table table-striped border'>
                <thead>
                  <tr>
                    <th>Assigned To: </th>
                    <td><DocumentAssign documentDetail={documentDetails} callBack={getDetailsWithTimeline} /></td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>Department</th>
                    <td>
                      <DocumentMasterUpdate 
                        documentId={documentDetails.id}
                        masterName="department" 
                        masterId={documentDetails.department}  
                        masters={masters} 
                        getMasterLabel={getMasterLabel} 
                        callBack={getDetailsWithTimeline}
                      /> 
                    </td>
                  </tr>
                  <tr>
                    <th>Category</th>
                    <td>
                      <DocumentMasterUpdate 
                        documentId={documentDetails.id}
                        masterName="document-category" 
                        masterId={documentDetails.category}  
                        masters={masters} 
                        getMasterLabel={getMasterLabel} 
                        callBack={getDetailsWithTimeline}
                      /> 
                    </td>
                  </tr>
                  <tr>
                    <th>Document Type</th>
                    <td>
                      <DocumentMasterUpdate 
                        documentId={documentDetails.id}
                        masterName="document-type" 
                        masterId={documentDetails.documentType}  
                        masters={masters} 
                        getMasterLabel={getMasterLabel} 
                        callBack={getDetailsWithTimeline}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th>Current Status</th>
                    <td>
                      <DocumentMasterUpdate 
                        documentId={documentDetails.id}
                        masterName="document-status" 
                        masterId={documentDetails.documentStatus}  
                        masters={masters} 
                        getMasterLabel={getMasterLabel} 
                        callBack={getDetailsWithTimeline}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      }


      {timelinLoading &&
        <div className='col-md-12 mt-5 text-center'>
          <CircularProgress/>
        </div>
      }

      {documentTimeline && !timelinLoading &&
        <div className='col-md-12'>
          <DocumentTimeline activityList={documentTimeline} callBack={getTimeLine} />
        </div>
      }
    </div>
  )
}

export default DocumentDetailsComponent;